import { render, staticRenderFns } from "./ratePlanDetail.vue?vue&type=template&id=34c1de74&scoped=true"
import script from "./ratePlanDetail.vue?vue&type=script&lang=js"
export * from "./ratePlanDetail.vue?vue&type=script&lang=js"
import style0 from "./ratePlanDetail.vue?vue&type=style&index=0&id=34c1de74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1de74",
  null
  
)

export default component.exports